module.exports = __webpack_public_path__ + "img/logout.ce6ca36c.svg";